import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import PlanAssignmentPage from "../components/pages/planAssignment/PlanAssignmentPage";

export const mapStateToProps = (state: any, props: any) => {
  return {
    isLoading: state.shipper.isLoading,
    isError: state.shipper.isError,
    error: state.shipper.error,
    isPlanAssigned: state.shipper.isPlanAssigned,
    isEdit: false,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    assignPlan: (payload: string[]) => dispatch(actions.assignPlan(payload)),
  };
};

const PlanAssignmentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlanAssignmentPage);
export default PlanAssignmentContainer;
